import { Component, ViewChild } from '@angular/core';
import { SearchFilterComponent } from 'src/app/components/search-filter/search-filter.component';
import { PagerControlComponent } from 'src/app/components/controls/pager/pager-control.component';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { MenuService } from 'src/app/services/menu.service';
import { IFilterResponse, SearchFilter } from 'src/app/infrastructure/iFilter-component';
import { MedicalFeeControlSearchItem } from '../../../model/medical-fee/medical-fee-control-search-item';
import { SelectionModel } from '@angular/cdk/collections';
import { MedicalFeeControlService } from '../../../services/medical-fee/medical-fee-control.service';
import { MedicalFeeState } from '../../../enums/medical-fee-state.enum';
import { NoMedicalFeeReasonDialogComponent, NoMedicalFeeDialogResponse } from '../../dialogs/no-medical-fee-reason-dialog/no-medical-fee-reason-dialog.component';
import { CsvExportService } from '../../../services/export/csv-export.service';
import { MedicalFeeControlSearchItemExport } from '../../../model/medical-fee/medical-fee-control-search-item-export';
import {  Router } from '@angular/router';
import { ValorizationService } from '../../../services/valorization/valorization.service';


@Component({
  selector: 'app-medical-fee-control-search',
  templateUrl: './medical-fee-control-search.component.html',
  styleUrls: ['./medical-fee-control-search.component.css']
})
export class MedicalFeeControlSearchComponent {

  @ViewChild('searchFilter', {static: false}) searchFilter: SearchFilterComponent;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;

  selection = new SelectionModel<MedicalFeeControlSearchItem>(true, []);
  dataSource = new MatTableDataSource([]);
  loading: boolean;
  loadingAction: boolean;
  searchFilters: SearchFilter[];

  displayedColumns: string[] = [
                  'Select', 'Date', 'ExecutionDate', 'PatientFullName',
                  'Protocol', 'PracticeRegionName', 'MedicalFeeAmount',
                  'ActionName', 'PhysicianFullName', 'StateName',
                  'CenterName', 'EntityName', 'ServiceName', 'Amount',
                  'Action'
                ];

  constructor( public dialog: MatDialog,
               private medicalFeeControlService: MedicalFeeControlService,
               private notificationToastService: NotificationToastService,
               private csvExportService: CsvExportService,
               private valorizationService: ValorizationService,
               private menuService: MenuService) {
    this.menuService.setMenuTitle('Honorarios', 'Control');
  }

  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.pager.getAllItems().forEach(row => this.selection.select(row));
  }

  isAllSelected() {
    if (this.selection.selected && this.pager.getAllItems()) {
      const numSelected = this.selection.selected.length;
      const numRows = this.pager.getAllItems().length;
      return numSelected === numRows;
    } else {
      return false;
    }
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  onEndSearch(response: IFilterResponse<MedicalFeeControlSearchItem>) {
    this.selection = new SelectionModel<MedicalFeeControlSearchItem>(true, []);
    this.searchFilters = response.searchFilters;
    this.pager.setItems(response.items);
  }

  onStartSearch() {
    this.loading = true;
  }

  async changeControledState() {
    if ( this.getSelectedValorizationFeeId().length > 0 ) {
      if ( await this.changeState( MedicalFeeState.controled ) ) {
        this.searchFilter.search();
      }
    }
  }

  async changePreFeeState() {
    if ( this.getSelectedValorizationFeeId().length > 0 ) {
      if ( await this.changeState( MedicalFeeState.preFee ) ) {
        this.searchFilter.search();
      }
    }
  }

  async changeDownState() {
    if ( this.getSelectedValorizationFeeId().length > 0 ) {
      if ( await this.changeState( MedicalFeeState.down ) ) {
        this.searchFilter.search();
      }
    }
  }

  async changeNoFeeState() {

    if ( this.getSelectedValorizationFeeId().length > 0 ) {

      const dialogRef = this.dialog.open(NoMedicalFeeReasonDialogComponent, {
        width: '50%'
      });

      dialogRef.afterClosed().subscribe(async (response: NoMedicalFeeDialogResponse) => {
         if ( response ) {
          if ( await this.changeState( MedicalFeeState.noFee, response.observations,
                response.noMedicalFeeReason.Id) ) {
            this.searchFilter.search();
          }
         }
      });
    }
  }

  async changeState( medicalFeeStateId: number,
    description: string = '', noMedicalFeeReasonId?: number ): Promise<boolean> {

    try {
      this.loading = true;
      return await this.medicalFeeControlService.changeState(
          this.getSelectedValorizationFeeId(),
          medicalFeeStateId, description,
          noMedicalFeeReasonId);
    } catch ( err ) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Liquidación honorarios');
    } finally {
      this.loading = false;
    }
  }

  async roolBackState() {
    if ( this.getSelectedValorizationFeeId().length > 0 ) {
      try {
        this.loading = true;
        await this.medicalFeeControlService.rollBackChangeState(
            this.getSelectedValorizationFeeId());
        this.searchFilter.search();
      } catch ( err ) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Liquidación honorarios');
      } finally {
        this.loading = false;
      }
    }
  }

  async recalculate(medicalFeeControlSearchItem: MedicalFeeControlSearchItem) {

    try {

      this.loadingAction = true;
      this.valorizationService
        .recalculateMedicalFeeBillingValorization( medicalFeeControlSearchItem );
      this.searchFilter.search();

    } catch ( err ) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Liquidación honorarios');
    } finally {
      this.loadingAction = false;
    }
  }

  exportCsv() {
    if (this.pager.getAllItems()) {

      const items: MedicalFeeControlSearchItemExport[] = [];

      const columns: string[] = ['Fecha',
      'FechaEjecucion', 'Paciente', 'Protocolo', 'Practica',
      'Importe', 'Accion', 'Medico', 'Estado', 'Centro',
      'Entidad', 'Servicio', 'Cantidad'];

      this.pager.getAllItems().forEach((item) => {
        const itemExport = new  MedicalFeeControlSearchItemExport();
        itemExport.Fecha = item.Date;
        itemExport.FechaEjecucion = item.ExecutionDate;
        itemExport.Paciente = item.PatientFullName;
        itemExport.Protocolo = item.Protocol;
        itemExport.Practica = item.PracticeName;
        itemExport.Importe = item.MedicalFeeAmount;
        itemExport.Accion = item.ActionName;
        itemExport.Medico = item.PhysicianFullName;
        itemExport.Estado = item.StateName;
        itemExport.Centro = item.CenterName;
        itemExport.Entidad = item.EntityName;
        itemExport.Servicio = item.ServiceName;
        itemExport.Cantidad = item.Amount;
        items.push(itemExport);
      });
      this.csvExportService.downloadFile(items, columns, 'liquidacion_honorarios');
    }
  }

  private getSelectedValorizationFeeId(): number[] {

    if ( this.selection.selected.length === 0 ) {
      return [];
    }

    return this.selection.selected
        .filter(s => s.ValorizationFeeId !== null)
        .map( s => s.ValorizationFeeId );
  }
}
